import { render } from "./FormRatingComponent.vue?vue&type=template&id=0fa736da&scoped=true"
import script from "./FormRatingComponent.vue?vue&type=script&lang=js"
export * from "./FormRatingComponent.vue?vue&type=script&lang=js"

import "./FormRatingComponent.vue?vue&type=style&index=0&id=0fa736da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa736da"]])

export default __exports__